import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { addReqiredMessage } from '../../util/addRequiredMessage';
import { useForm } from '@/form/useForm.ts';

export const ContactPersonSummaryFormIN = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['contactPersons'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  //contactFirstname  contactLastname  contactRelationship  contactPhoneNumber  contactEmailAddress
  //contactFirstname
  const contactFirstnameField = addReqiredMessage({
    field: s.contactPersons.fields.find(({ name }) => name === 'contactFirstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const contactFirstnameLabel = translate(contactFirstnameField?.label);

  // contactLastname
  const contactLastnameField = addReqiredMessage({
    field: s.contactPersons.fields.find(({ name }) => name === 'contactLastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const contactLastnameLabel = translate(contactLastnameField?.label);

  // contactRelationship
  const contactRelationshipField = addReqiredMessage({
    field: s.contactPersons.fields.find(({ name }) => name === 'contactRelationship'),
    message: s.dataSummary.requiredMessage!,
  });
  const contactRelationshipLabel = translate(contactRelationshipField?.label);

  // contactPhoneNumber
  const contactPhoneNumberField = addReqiredMessage({
    field: s.contactPersons.fields.find(({ name }) => name === 'contactPhoneNumber'),
    message: s.dataSummary.requiredMessage!,
  });
  const contactPhoneNumberLabel = translate(contactPhoneNumberField?.label);

  // contactEmailAddress
  const contactEmailAddressField = s.contactPersons.fields.find(({ name }) => name === 'contactEmailAddress');
  const contactEmailAddressLabel = translate(contactEmailAddressField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-contact-person'}>
      <h2>{translate(s.dataSummary.titles?.firstContactPerson)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{contactFirstnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('contactFirstname')}
          {editMode && <EditDataField field={contactFirstnameField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{contactLastnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('contactLastname')}
          {editMode && <EditDataField field={contactLastnameField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{contactRelationshipLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('contactRelationship')}
          {editMode && <EditDataField field={contactRelationshipField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{contactPhoneNumberLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('contactPhoneNumber')}
          {editMode && <EditDataField field={contactPhoneNumberField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{contactEmailAddressLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('contactEmailAddress')}
          {editMode && <EditDataField field={contactEmailAddressField!} slideId={'contactPersons'} />}
        </div>
      </div>
    </div>
  );
};
